import React from 'react';
import { CONTACT } from '../../data/navigation';
interface SalesCalloutProps {
  location: string;
  note?: string;
}
export function SalesCallout({
  location,
  note
}: SalesCalloutProps) {
  return <aside aria-labelledby={`sales-${location}`} className="flex flex-col gap-5 border border-rule border-l-2 border-l-cta bg-white p-6 sm:p-7 md:flex-row md:items-center md:justify-between md:gap-10" data-id="element-569" data-mp="3ekhokgtx3izp">
      <div data-id="element-570" data-mp="35le4b9j0kxjm">
        <h2 id={`sales-${location}`} className="font-display text-[20px] font-medium leading-snug text-navy" data-id="element-571" data-mp="35lxeu56c4jnm">
          Call for pricing and availability
        </h2>
        <p className="mt-1.5 text-[14px] leading-relaxed text-graphite/80" data-id="element-572" data-mp="2vv2rexhcre0l">
          {note ?? 'Pricing, availability and ordering are handled directly by sales. There is no online purchasing.'}
        </p>
      </div>
      <div className="flex shrink-0 flex-col gap-2 sm:flex-row sm:items-center sm:gap-4" data-id="element-573" data-mp="2mvo2i2gu3bi7">
        <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-line="sales" data-analytics-location={location} className="inline-flex min-h-[48px] items-center justify-center whitespace-nowrap bg-cta px-6 font-mono text-[15px] font-semibold text-navy transition-colors duration-150 ease-precise hover:bg-navy hover:text-white" data-id="element-574" data-mp="2hwuz52v9h0vr">
          {CONTACT.phoneLabel}
        </a>
        <a href={CONTACT.emailHref} data-analytics="email-click" data-analytics-location={location} className="inline-flex min-h-[48px] items-center justify-center whitespace-nowrap border border-rule px-5 text-[14px] font-medium text-navy transition-colors duration-150 ease-precise hover:border-copper hover:text-copper" data-id="element-575" data-mp="2s61o4ktnkjda">
          {CONTACT.email}
        </a>
      </div>
    </aside>;
}